import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { Text } from '../text/Text'
import { GRID_ROW_HEIGHT } from '../grid/utils/grid.constants'
import { fontSize } from '../../foundation/fontSize'

const gridCellTextStyles = css({
  display: 'block',
  width: '100%',
  height: GRID_ROW_HEIGHT,
  lineHeight: `${GRID_ROW_HEIGHT}px`,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
})

const textStyles = css({
  fontSize: fontSize.X15,
})

interface Props {}

export const GridCellText: FunctionComponent<Props> = ({ children }) => (
  <Text css={gridCellTextStyles} styles={textStyles}>
    {children}
  </Text>
)
